import type { AccountFeatureFlag } from '@/services/auth/feature-flags';
import { hasFeatureFlag } from '@/services/auth/feature-flags';

/**
 * Renders children only when the given feature flag is enabled.
 * Falls back to a custom fallback or renders nothing by default.
 * Catches errors during flag evaluation and falls back gracefully.
 */

type FeatureFlagGuardProps = {
  flag: AccountFeatureFlag;
  fallback?: React.ComponentType;
  children: React.ReactNode;
};

export function FeatureFlagGuard({ flag, fallback: Fallback, children }: FeatureFlagGuardProps) {
  try {
    if (!hasFeatureFlag(flag)) {
      return Fallback != null ? <Fallback /> : null;
    }
  } catch {
    return Fallback != null ? <Fallback /> : null;
  }

  return <>{children}</>;
}
